<div class="progress-container">
  <div class="progress-bar">
    <div 
      class="progress-fill"
      [style.width.%]="value">
      <!-- Blurred border effect -->
      <div class="blur-border"></div>
      <!-- Solid border overlay -->
      <div class="solid-border"></div>
    </div>
  </div>
  <hyperkit-typography class="progress-text" variant="label2" color="secondary" align="right">{{value}}%</hyperkit-typography>
</div>